(function () {
  if (window.__noendyEffects) return;
  window.__noendyEffects = true;

  /* JS-ready hint for CSS rules that should only apply when JS is active */
  document.documentElement.classList.add('noendy-js');

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----- Scroll progress bar ----- */
  function initScrollProgress() {
    const bar = document.querySelector('.noendy-scroll-progress__bar');
    if (!bar) return;
    let ticking = false;
    function update() {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const pct = max > 0 ? (window.scrollY / max) * 100 : 0;
      bar.style.width = pct + '%';
      ticking = false;
    }
    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
    update();
  }

  /* ----- Back to top ----- */
  function initBackToTop() {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'noendy-back-to-top';
    btn.setAttribute('aria-label', 'Yukarı çık');
    btn.innerHTML = `
      <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
        <path d="M12 4l-8 8h5v8h6v-8h5z"/>
      </svg>
    `;
    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    document.body.appendChild(btn);

    let last = 0;
    function update() {
      const show = window.scrollY > 600;
      if (show !== last) {
        btn.classList.toggle('is-visible', show);
        last = show;
      }
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ----- Section reveal on scroll ----- */
  function initSectionReveal() {
    const sections = document.querySelectorAll('.section[class*="section--noendy-"]');
    if (sections.length === 0) return;
    if (!('IntersectionObserver' in window) || reduceMotion) {
      sections.forEach((s) => s.classList.add('is-in-view'));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    sections.forEach((s) => observer.observe(s));
  }

  /* ----- Blur-up images ----- */
  function initBlurUp() {
    if (reduceMotion) return;
    document.querySelectorAll('img.noendy-blur-up:not(.is-loaded)').forEach((img) => {
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('is-loaded');
        return;
      }
      img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
      img.addEventListener('error', () => img.classList.add('is-loaded'), { once: true });
    });
  }

  /* ----- Page-leave transition ----- */
  function initPageTransition() {
    if (reduceMotion) return;
    // Initial cleanup — eski oturumdan kalan class'ı sıfırla
    document.documentElement.classList.remove('noendy-page-leaving');

    document.addEventListener('click', (e) => {
      // PreventDefault yapılmış ise (search trigger, dropdown summary vs.) navigate olmaz, class ekleme
      if (e.defaultPrevented) return;
      const link = e.target.closest('a[href]');
      if (!link) return;
      // aria-controls'lu link'ler dialog/dropdown trigger — navigate etmez
      if (link.hasAttribute('aria-controls')) return;
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;
      if (link.target === '_blank') return;
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      try {
        const url = new URL(href, location.href);
        if (url.origin !== location.origin) return;
        if (url.pathname === location.pathname && url.search === location.search) return;
      } catch (_e) {
        return;
      }
      document.documentElement.classList.add('noendy-page-leaving');
    });
    window.addEventListener('pageshow', () => {
      document.documentElement.classList.remove('noendy-page-leaving');
    });
  }

  /* ----- Confetti ----- */
  const CONFETTI_COLORS = ['#5A1E2C', '#FFDE59', '#0C162C', '#5A1E2C', '#E8AFAF'];
  function launchConfetti(count) {
    if (reduceMotion) return;
    const layer = document.createElement('div');
    layer.className = 'noendy-confetti';
    document.body.appendChild(layer);
    const n = count || 80;
    for (let i = 0; i < n; i++) {
      const piece = document.createElement('span');
      piece.className = 'noendy-confetti__piece';
      const left = Math.random() * 100;
      const drift = (Math.random() - 0.5) * 240;
      const color = CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)];
      const delay = Math.random() * 0.4;
      piece.style.left = left + 'vw';
      piece.style.background = color;
      piece.style.setProperty('--noendy-confetti-drift', drift + 'px');
      piece.style.animationDelay = delay + 's';
      piece.style.transform = `rotate(${Math.random() * 360}deg)`;
      layer.appendChild(piece);
    }
    setTimeout(() => layer.remove(), 3500);
  }

  window.NoendyEffects = { launchConfetti };

  /* Confetti on successful order */
  function maybeConfettiOnThankYou() {
    if (location.pathname.includes('/thank_you') || location.pathname.includes('/orders/')) {
      setTimeout(() => launchConfetti(120), 500);
    }
  }

  function init() {
    initScrollProgress();
    /* initBackToTop(); — kaldırıldı (kullanıcı isteği) */
    initSectionReveal();
    initBlurUp();
    initPageTransition();
    maybeConfettiOnThankYou();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    initBlurUp();
    initSectionReveal();
  });
})();
